class TeacherDocument {
	id = null;
	uploaded_file = {
		name: '',
		link: '',
		original_name: '',
		upload_id: null,
	};
	teacher_id = null;
	name = '';

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default TeacherDocument;
